import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useSignalRReducer = () =>
  useSelector((state: ApplicationState) => state.signalR);
